const AllRolesAndPermissions = () =>
  import("./views/AllRolesAndPermissions.vue");
const RolesAndPermissionsForm = () =>
  import("./views/RolesAndPermissionsForm.vue");
const ViewRoleAndPermissions = () =>
  import("./views/ViewRoleAndPermissions.vue");

export default [
  {
    path: "view-all",
    component: AllRolesAndPermissions,
  },
  {
    path: "create",
    component: RolesAndPermissionsForm,
  },
  {
    path: "edit/:id",
    component: RolesAndPermissionsForm,
  },
  {
    path: "view/:id",
    component: ViewRoleAndPermissions,
    name: "viewRoleAndPermissions",
  },
];
